import dict from './dict';
import config from './config';

export default {
    sys_manage: { routerName: '系统管理' },
    ...dict,
    ...config,
};
